import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CampaignsTab } from 'src/features/manage-clients/campaigns/campaigns-tab';
import { SchedulingTab } from 'src/features/manage-clients/scheduling/scheduling-tab';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/components/ui/tabs';

const ManageLaunchedCampaignsTab = () => {
  const [searchParams] = useSearchParams();
  const [activeSubTab, setActiveSubTab] = useState<'campaign-requests' | 'meetings'>('campaign-requests');

  useEffect(() => {
    if (searchParams.get('meetings') === '1') {
      setActiveSubTab('meetings');
    }
  }, [searchParams]);

  return (
    <div className="h-full overflow-hidden">
      <Tabs
        value={activeSubTab}
        onValueChange={(value) => setActiveSubTab(value as 'campaign-requests' | 'meetings')}
        className="flex h-full flex-col"
      >
        <div className="border-b border-[#EDEEF2] px-6 pt-6 sm:px-10">
          <TabsList className="h-auto rounded-none bg-transparent p-0">
            <TabsTrigger
              value="campaign-requests"
              className="mr-8 rounded-none border-b-2 border-transparent bg-transparent px-0 pb-3 text-[14px] font-semibold text-[#5E6278] shadow-none hover:bg-transparent hover:text-[#0D0F1A] [&[aria-selected=true]]:border-[#0D0F1A] [&[aria-selected=true]]:bg-transparent [&[aria-selected=true]]:text-[#0D0F1A] [&[aria-selected=true]]:shadow-none"
            >
              Campaign Requests
            </TabsTrigger>
            <TabsTrigger
              value="meetings"
              className="rounded-none border-b-2 border-transparent bg-transparent px-0 pb-3 text-[14px] font-semibold text-[#5E6278] shadow-none hover:bg-transparent hover:text-[#0D0F1A] [&[aria-selected=true]]:border-[#0D0F1A] [&[aria-selected=true]]:bg-transparent [&[aria-selected=true]]:text-[#0D0F1A] [&[aria-selected=true]]:shadow-none"
            >
              Meetings
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent
          value="campaign-requests"
          className="mt-0 min-h-0 flex-1 overflow-hidden"
        >
          <CampaignsTab />
        </TabsContent>

        <TabsContent
          value="meetings"
          className="mt-0 min-h-0 flex-1 overflow-hidden"
        >
          <SchedulingTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ManageLaunchedCampaignsTab;
